import { IsDevEnv } from '@/app'
import { getFirebase } from '../../firebaseApp'

const DEBUG = IsDevEnv && false

export const userHasSocialLogin = async () => {
  if (IsDevEnv && DEBUG) return { hasSocialLogin: true }

  const firebase = await getFirebase()

  const firebaseUser = firebase.auth().currentUser

  const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(firebaseUser?.email)

  const idTokenResult = await firebaseUser.getIdTokenResult()

  if (idTokenResult?.claims?.linkedin_id) {
    return { hasSocialLogin: true, signInMethod: 'linkedIn' }
  }

  const hasSocialLogin = signInMethods?.some(x => x !== 'password')

  return { hasSocialLogin, signInMethod: signInMethods[0] }
}